import React from "react";
import "./styles.css";

const Header = () => (
  <header className="home-header">
    <br />
    <br />
    <h1>Inqiri Search</h1>
    <p>Learn some new stuff</p>
  </header>
);

export default Header;
